import { attendancesApi } from "./attendances.api";

export const { useGetAttendancesTodayByCompanyQuery, useSaveAttendancesMutation, useUpdateAttendancesMutation } = attendancesApi;
